import { asNumber, asRecord, clampNumber } from '@/utils/coerce'
import type { FileSettings } from '@/types/api'

const DEFAULT_SETTINGS: Readonly<FileSettings> = {
  smooth_shading: true,
  smoothing_angle: 24,
  rotation: { x: 0, y: 0, z: 0 },
  custom_scale: 1,
} as const

export const ANGLE_MIN = 0
export const ANGLE_MAX = 180
export const ROTATION_MIN = -360
export const ROTATION_MAX = 360

const SCALE_MIN = 0.01
const SCALE_MAX = 100

export function clampSettings(settings: FileSettings): FileSettings {
  return {
    smooth_shading: settings.smooth_shading,
    smoothing_angle: clampNumber(
      settings.smoothing_angle,
      ANGLE_MIN,
      ANGLE_MAX,
      DEFAULT_SETTINGS.smoothing_angle,
    ),
    rotation: {
      x: clampNumber(settings.rotation.x, ROTATION_MIN, ROTATION_MAX, DEFAULT_SETTINGS.rotation.x),
      y: clampNumber(settings.rotation.y, ROTATION_MIN, ROTATION_MAX, DEFAULT_SETTINGS.rotation.y),
      z: clampNumber(settings.rotation.z, ROTATION_MIN, ROTATION_MAX, DEFAULT_SETTINGS.rotation.z),
    },
    custom_scale: clampNumber(
      settings.custom_scale,
      SCALE_MIN,
      SCALE_MAX,
      DEFAULT_SETTINGS.custom_scale,
    ),
  }
}

export function resolveSettings(raw: unknown): FileSettings {
  const source = asRecord(raw)
  const rotation = asRecord(source.rotation)

  return clampSettings({
    smooth_shading:
      typeof source.smooth_shading === 'boolean'
        ? source.smooth_shading
        : DEFAULT_SETTINGS.smooth_shading,
    smoothing_angle: asNumber(source.smoothing_angle, DEFAULT_SETTINGS.smoothing_angle),
    rotation: {
      x: asNumber(rotation.x, DEFAULT_SETTINGS.rotation.x),
      y: asNumber(rotation.y, DEFAULT_SETTINGS.rotation.y),
      z: asNumber(rotation.z, DEFAULT_SETTINGS.rotation.z),
    },
    custom_scale: asNumber(source.custom_scale, DEFAULT_SETTINGS.custom_scale),
  })
}
